export default __webpack_public_path__ + "static/gif-automotive-d33ad4f3339bbf7ea396961c68982230.gif";